<template>
  <div class="pod-status">
    <span class="text-danger" v-if="docket.containsPOD === true && docket.goodPod === false">
      <i class="fas fa-times"></i> Bad
    </span>
    <span class="text-primary" v-if="docket.containsPOD === true && docket.goodPod === null">
      <i class="fas fa-exclamation-triangle"></i>  Unverified
    </span>
    <span class="text-success" v-if="docket.containsPOD === true && docket.goodPod === true">
       <i class="fas fa-check"></i> Good
    </span>
    <span class="text-info" v-if="docket.containsPOD === false && docket.cancelled === false">
      <i class="fas fa-file-exclamation"></i> Pending
    </span>
    <span class="text-warning" v-if="docket.cancelled === true">
      <i class="fas fa-ban"></i> Cancelled
    </span>
  </div>
</template>

<script>
export default {
  name: 'PODStatus',
  props: ['docket'],
  data () {
    return {}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
  .pod-status {
    width: 120px;
    font-size: .6rem;
  }
  .table-sm .pod-status {
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PODStatus.vue